export const MODULE_SET_MANY = 'MODULE_SET_MANY';
